import {IntermediatePart} from "../intermediatePart";
export default class NonVisualizerSubPart extends IntermediatePart {
  constructor(isChild, partId, partName) {
    super(isChild);
    this.partId = partId;
    this.visible = true;
    this.partName = partName;
    // this.allFeaturesReceived = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new NonVisualizerSubPart(false, this.partId, dbFeature.groupName));
  }

  navigationSubItems(filters, searchText) {
    return this.navigationNoMetaSubItems(filters, searchText)
  }
}
